<template>
  <div
    class="widget"
    :class="{ open: props.open }"
  >
    <m-widget-head :compact="!props.open">
      <slot name="left-head"></slot>
      <template slot="right">
        <!--span style="width: 40px;"></span-->
        <!--icon-button @click="props.open = !props.open">
          <arrow-icon :direction="props.open ? 'up' : 'down'"></arrow-icon>
        </icon-button-->
        <slot name="right-head"></slot>
      </template>
    </m-widget-head>
    <div class="widget-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import MWidgetHead from '@/components/widget/MWidgetHead'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'

export default {
  components: {
    MWidgetHead,
    IconButton,
    ArrowIcon
  },
  props: {
    open: Boolean
  },
  data () {
    return {
      props: {
        open: this.open
      }
    }
  }
}
</script>

<style scoped>
.widget-body { display: none; }
.open .widget-body { display: block; padding: 0 0; position: relative; }
</style>



// WEBPACK FOOTER //
// src/components/widget/MWidgetBetslip.vue